import React from 'react';
import { Calendar, Clock, User, ArrowRight } from 'lucide-react';

const FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80';

const BlogFeaturedPost = ({ post, onOpen }) => (
  <section className="py-20 bg-slate-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center space-y-4 mb-16">
        <h2 className="text-4xl font-bold text-white">
          Featured
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Article</span>
        </h2>
      </div>

      <div className="bg-slate-800/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-slate-700 hover:border-amber-500/50 transition-all duration-300 hover:-translate-y-2">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          <div className="aspect-w-16 aspect-h-9 lg:aspect-none">
            <img
              src={post.image || FALLBACK_IMAGE}
              alt={post.title}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="p-8 space-y-6">
            <div className="flex items-center space-x-4 text-sm text-slate-400">
              <div className="flex items-center space-x-2">
                <User size={16} />
                <span>{post.author}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Calendar size={16} />
                <span>{new Date(post.date).toLocaleDateString()}</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock size={16} />
                <span>{post.readTime}</span>
              </div>
            </div>

            <h3 className="text-3xl font-bold text-white leading-tight">{post.title}</h3>

            <p className="text-slate-300 text-lg leading-relaxed">{post.excerpt}</p>

            <button
              onClick={() => onOpen(post)}
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-amber-500 to-orange-500 text-slate-900 px-6 py-3 rounded-lg font-semibold hover:from-amber-400 hover:to-orange-400 transition-all duration-200"
            >
              <span>Read Full Article</span>
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BlogFeaturedPost;
